module.exports = __webpack_public_path__ + "img/footer-bg.268812be.png";